import React, { FC } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import classnames from "classnames";
import { PartialShowcase } from "../../types/types";
import styles from "./Cards.module.scss";
import { RichText } from "prismic-reactjs";
import { Tags } from "../Tag/Tag";
import StarIcon from "../../assets/heroicons/star.svg";
import { Button } from "../Button/Button";
import PlayIcon from "../../assets/heroicons/play.svg";
import DownloadIcon from "../../assets/heroicons/download.svg";

export interface ShowcaseCardProps {
	content: PartialShowcase;
}

export const ShowcaseCard: FC<ShowcaseCardProps> = ({
	content: {
		tags,
		data: { image, title, is_featured, summary, link, importlink },
	},
}) => {
	return (
		<article className={styles.card}>
			<div className={styles.imageContainer}>
				<a
					href={link.url}
					className={styles.link}
					target="_blank"
					rel="noreferrer"
				>
					<GatsbyImage
						image={image.fluid}
						className={styles.image}
						alt={image.alt || title}
					/>
				</a>
				{is_featured && (
					<span className={classnames([styles.featuredFlag, styles.game])}>
						<StarIcon
							focusable="false"
							aria-hidden="true"
							className={styles.icon}
						/>
						Featured
					</span>
				)}
			</div>
			<div className={styles.text}>
				<h2 className={styles.heading}>
					{/* <a
						href={link.url}
						className={styles.link}
						target="_blank"
						rel="noreferrer"
					> */}
					{title}
					{/* </a> */}
				</h2>
				{/* {author?.document?.data?.name && (
					<p className={styles.author}>By {author.document.data.name}</p>
				)} */}
				{summary?.richText && <RichText render={summary.richText} />}
				{tags && tags.length > 0 && <Tags tags={tags} />}
				<div className={styles.buttons}>
					{link?.url && (
						<Button
							to={link.url}
							target="_blank"
							className={styles.fullWidthButton}
						>
							<PlayIcon
								focusable="false"
								aria-hidden="true"
								className={styles.icon}
							/>
							Play game
						</Button>
					)}
					{importlink?.url && (
						<Button
							variant="secondary"
							to={importlink.url}
							target="_blank"
							className={styles.fullWidthButton}
						>
							<DownloadIcon
								focusable="false"
								aria-hidden="true"
								className={styles.icon}
							/>
							Import
						</Button>
					)}
				</div>
			</div>
		</article>
	);
};
